import type { IntlKey } from 'locales';

import { useSPIntl } from './useIntl';

export const useTranslation = (translationKey: IntlKey, defaultMessage?: string): string => {
  const intl = useSPIntl();

  return intl.formatMessage({
    id: translationKey,
    defaultMessage,
  });
};
